import { useCallback, useRef } from 'react';

// Pass the hook's refetch trigger: if it changed before the first fetch (a server miss), the fetch isn't skipped.
export default function useSkipFirstFetchIfResolvedOnServer(
  resolvedOnServer?: boolean,
  initialTrigger?: unknown
) {
  const isFirstRenderAndResolvedOnServer = useRef(Boolean(resolvedOnServer));
  const initialTriggerRef = useRef(initialTrigger);

  return useCallback((trigger?: unknown) => {
    if (isFirstRenderAndResolvedOnServer.current) {
      isFirstRenderAndResolvedOnServer.current = false;

      return trigger === initialTriggerRef.current;
    }

    return false;
  }, []);
}
